import NotFound from '~/client/components/NotFound'

export default function NotFoundPage() {
  return <NotFound/>
}
